// Reviewed day/night designs are available on the Atlas host and local previews.
export function hasLightDesign({pathname, search}, origin) {
  const url = new URL(origin);
  const enabled = (url.hostname === 'essence-atlas.com' && ['', '443', '18443'].includes(url.port))
    || ['localhost', '127.0.0.1'].includes(url.hostname);
  return enabled && (
    /^\/praxis-tool\/(home|learning|patients|cases|prescriptions|solved-cases|intake-form|case-questions|knowledge|remedies|admin|login|register|account)(\/|$)/.test(pathname)
    || ['/', '/praxis-tool', '/welcome', '/discover-v2', '/about', '/contact', '/sources-and-images', '/how-learning-works', '/impressum', '/datenschutz'].includes(pathname)
  );
}
export function isDaylightAppearance(location, origin, preference = 'dark') {
  const appearance = new URLSearchParams(location.search).get('appearance');
  return hasLightDesign(location, origin)
    && (['light', 'dark'].includes(appearance) ? appearance : preference) === 'light';
}
// These additional image/frame refinements belong only to the established detail.
export function isGalleryPreview(location, origin, preference = 'dark') {
  const query = new URLSearchParams(location.search);
  return isDaylightAppearance(location, origin, preference)
    && location.pathname === '/praxis-tool/learning'
    && Boolean(query.get('remedy')) && !query.has('learn')
    && query.get('author') !== 'mangialavori';
}
